import { TuiButton } from "@taiga-ui/core";
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '@src/app/components';

import { ListModule } from '../list';

import { SearchGroupsComponent } from './search-groups.component';

@NgModule({
  declarations: [SearchGroupsComponent],
  imports: [CommonModule, FormsModule, ListModule, TuiButton, TranslateModule, ComponentsModule],
  exports: [SearchGroupsComponent],
})
export class SearchGroupsModule {}
